import icon from 'assets/icons/martonticket-logo.png'
import { SelectButton } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { useIsPhone } from 'hooks/admin/useIsPhone'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import React, { useEffect, useMemo, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { UserRole } from 'types/Organization'

import {
    Center,
    CustomNavLink,
    HamburgerIcon,
    Left,
    Logo,
    NavbarContainer,
    NavbarWrapper,
    NavLinks,
    Right,
    SuperAdminBar,
    UserIcon,
    Username,
    UsernameContainer,
} from './navbar.style'

export const Navbar: React.FC = () => {
    const { data } = useOrganizations()
    const isPhone = useIsPhone()
    const location = useLocation()

    const { currentAccount, isLoadingCurrentAccount, errorCurrentAccount } = useCurrentAccount()

    const isSuperAdmin = currentAccount?.role === UserRole.superAdmin

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

    const shouldShowBackButton = useMemo(() => {
        return isPhone && window.history.length > 2 && location.pathname.includes('jegyellenorzes')
    }, [isPhone, location.pathname])

    const superAdminLinks = useMemo(
        () => [
            { to: '/admin/szervezetek', text: 'Szervezetek' },
            { to: '/kijelentkezes', text: 'Kijelentkezés' },
        ],
        [],
    )

    const orgAdminLinks = useMemo(
        () => [
            { to: '/admin/helyszinek', text: 'Helyszínek' },
            { to: '/admin/musor', text: 'Műsor' },
            { to: '/admin/esemenyek', text: 'Eseményeim' },
            { to: '/admin/jegyellenorzes', text: 'Ellenőrzés' },
            { to: '/kijelentkezes', text: 'Kijelentkezés' },
        ],
        [],
    )

    const phoneOrgAdminLinks = useMemo(
        () => [
            { to: '/admin/jegyellenorzes/esemenyvalasztas', text: 'Műsor kiválasztása' },
            { to: '/admin/jegyellenorzes', text: 'Jegyellenőrzés' },
            { to: '/admin/jegyellenorzes/telitettseg', text: 'Nézőtér telítettsége' },
            { to: '/kijelentkezes', text: 'Kijelentkezés' },
        ],
        [],
    )

    const userLinks = useMemo(
        () => [
            { to: '/esemenyek', text: 'Események' },
            { to: '/musor', text: 'Műsor' },
            { to: '/kapcsolat', text: 'Kapcsolat' },
        ],
        [],
    )

    const [navigationLinks, setNavigationLinks] = useState(userLinks)

    useEffect(() => {
        if (isLoadingCurrentAccount) return

        if (!currentAccount || errorCurrentAccount) {
            setNavigationLinks(userLinks)
            return
        }

        switch (currentAccount.role) {
            case UserRole.superAdmin:
                setNavigationLinks(superAdminLinks)
                break
            case UserRole.orgAdmin:
                setNavigationLinks(isPhone ? phoneOrgAdminLinks : orgAdminLinks)
                break
            default:
                setNavigationLinks(userLinks)
        }
    }, [
        currentAccount,
        errorCurrentAccount,
        isLoadingCurrentAccount,
        isPhone,
        orgAdminLinks,
        phoneOrgAdminLinks,
        superAdminLinks,
        userLinks,
    ])

    const userName = data?.find((org) => org.org_id === currentAccount?.orgId)?.name

    return (
        <div>
            <NavbarContainer>
                <NavbarWrapper>
                    <Left>
                        {shouldShowBackButton && (
                            <SelectButton icon="pi pi-arrow-left" onClick={() => (window.location.href = '/admin/jegyellenorzes')} />
                        )}
                    </Left>

                    <Center>
                        <Link to="/">
                            <Logo src={icon} alt="Logo" />
                        </Link>
                    </Center>

                    <Right>
                        <LoadingContainer isLoading={isLoadingCurrentAccount} error={null}>
                            <HamburgerIcon onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>&#9776;</HamburgerIcon>
                        </LoadingContainer>
                    </Right>

                    <NavLinks ismobilemenuopen={isMobileMenuOpen}>
                        {navigationLinks.map(({ to, text }) => (
                            <div key={to}>
                                <CustomNavLink to={to} end>
                                    {text}
                                </CustomNavLink>
                            </div>
                        ))}
                        {userName && (
                            <UsernameContainer>
                                <UserIcon className="pi pi-user"></UserIcon>
                                <Username>({userName})</Username>
                            </UsernameContainer>
                        )}
                    </NavLinks>
                </NavbarWrapper>
            </NavbarContainer>
            {isSuperAdmin && <SuperAdminBar>Superadmin fiók</SuperAdminBar>}
        </div>
    )
}
